export default __webpack_public_path__ + "static/media/member.82ff5d1d.svg";